import { render } from "./PatientCancellationWarning.vue?vue&type=template&id=68bf2cb7&ts=true"
import script from "./PatientCancellationWarning.vue?vue&type=script&lang=ts"
export * from "./PatientCancellationWarning.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/PatientDetail/PatientCancellationWarning.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68bf2cb7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68bf2cb7', __exports__)) {
    api.reload('68bf2cb7', __exports__)
  }
  
  module.hot.accept("./PatientCancellationWarning.vue?vue&type=template&id=68bf2cb7&ts=true", () => {
    api.rerender('68bf2cb7', render)
  })

}


export default __exports__